import { resetStoredSubTask } from 'platform/forms/sub-task';
import { FORM_STATUS_BDD, SAVED_SEPARATION_DATE } from '../constants';

// The form reads these to decide between the BDD and standard claim.
export const saveSavedSeparationDate = (date, isBdd) => {
  try {
    window.sessionStorage.setItem(SAVED_SEPARATION_DATE, date);
    window.sessionStorage.setItem(FORM_STATUS_BDD, isBdd ? 'true' : 'false');
  } catch (error) {
    // Storage blocked; the form falls back to the standard claim
  }
};

export const clearSavedSeparationDate = () => {
  try {
    window.sessionStorage.removeItem(SAVED_SEPARATION_DATE);
    window.sessionStorage.removeItem(FORM_STATUS_BDD);
  } catch (error) {
    // Storage blocked; nothing was stored
  }
};

export const resetScreenerSession = () => {
  try {
    resetStoredSubTask();
  } catch (error) {
    // Storage blocked; nothing was stored
  }
};
